(() => {
  if (customElements.get('alaia-size-guide')) return;
  customElements.define('alaia-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const category = event.target.closest('[data-asg-category]');
        if (category) {
          this.querySelectorAll('[data-asg-category]').forEach(button => button.setAttribute('aria-pressed', String(button === category)));
          this.querySelectorAll('[data-asg-panel]').forEach(panel => { panel.hidden = panel.dataset.asgPanel !== category.dataset.asgCategory; });
        }
        const unit = event.target.closest('[data-asg-unit]');
        if (unit) {
          this.querySelectorAll('[data-asg-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === unit)));
          this.querySelectorAll('[data-asg-cm]').forEach(cell => {
            const cm = Number(cell.dataset.asgCm);
            if (!Number.isFinite(cm)) return;
            cell.textContent = unit.dataset.asgUnit === 'in' ? `${Number((cm / 2.54).toFixed(1))} in` : `${cm} cm`;
          });
        }
      });
      this.querySelectorAll('[data-asg-measure]').forEach(detail => {
        detail.addEventListener('toggle', () => {
          if (detail.open) {
            this.querySelectorAll('[data-asg-measure]').forEach(other => { if (other !== detail) other.open = false; });
            this.querySelectorAll('[data-asg-line]').forEach(line => line.classList.toggle('is-active', line.dataset.asgLine === detail.dataset.asgMeasure));
          }
        });
      });
      this.querySelector('[data-asg-line="bust"]')?.classList.add('is-active');
    }
  });
})();
